"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationListEntry = void 0;
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const Badge_1 = require("../../sharedComponents/Badge");
const store_1 = require("../store");
const theme_1 = require("../../theme");
const Avatar_1 = require("../../sharedComponents/Avatar");
const ConversationBase_1 = require("./ConversationBase");
const ConversationListEntry = ({ conversation, onPress: onPressProp, }) => {
    var _a, _b;
    const theme = theme_1.useSharedTheme();
    const ownProfileGid = store_1.useOwnProfileGid();
    const partner = conversation.participants.find((participant) => participant.gid !== ownProfileGid);
    const currentConversationId = store_1.useCurrentConversationId();
    const onPress = react_1.useCallback(() => onPressProp(conversation.id), [
        conversation.id,
        onPressProp,
    ]);
    const selected = conversation.id === currentConversationId;
    const showBadge = conversation.meta.unreadMessageCount > 0;
    let badgeSize;
    if (conversation.meta.unreadMessageCount < 10) {
        badgeSize = Badge_1.BadgeSize.small;
    }
    else if (conversation.meta.unreadMessageCount < 100) {
        badgeSize = Badge_1.BadgeSize.medium;
    }
    else {
        badgeSize = Badge_1.BadgeSize.large;
    }
    const badgeContent = conversation.meta.unreadMessageCount < 1000
        ? `${conversation.meta.unreadMessageCount}`
        : '>1k';
    if (!partner)
        return null;
    return (react_1.default.createElement(react_native_1.TouchableOpacity, { style: [
            styles.constainer,
            selected ? { backgroundColor: theme.colors.background } : undefined,
        ], onPress: onPress },
        react_1.default.createElement(ConversationBase_1.ConversationBase, { image: react_1.default.createElement(Avatar_1.Avatar, { imageUri: partner.imageUrl }), showContentBottomBorder: true },
            react_1.default.createElement(react_native_1.View, { style: styles.content },
                react_1.default.createElement(react_native_1.View, { style: styles.nameDateRow },
                    react_1.default.createElement(react_native_1.Text, { style: styles.name, numberOfLines: 1 }, partner.name),
                    react_1.default.createElement(react_native_1.Text, { style: [styles.date, { color: theme.colors.textSoft }] }, conversation.updatedAt.toLocaleDateString('de'))),
                react_1.default.createElement(react_native_1.View, { style: styles.messageAndBadge },
                    react_1.default.createElement(react_native_1.Text, { style: [styles.teaser, { color: theme.colors.textSoft }], numberOfLines: 2 }, (_b = (_a = conversation.latestMessage) === null || _a === void 0 ? void 0 : _a.body) !== null && _b !== void 0 ? _b : ''),
                    showBadge ? (react_1.default.createElement(react_native_1.View, { style: styles.badgeContainer },
                        react_1.default.createElement(Badge_1.Badge, { size: badgeSize, badgeColor: theme.colors.negative, borderColor: theme.colors.negative },
                            react_1.default.createElement(react_native_1.Text, { style: [
                                    styles.badgeText,
                                    { color: theme.colors.textLight },
                                ] }, badgeContent)))) : null)))));
};
exports.ConversationListEntry = ConversationListEntry;
const styles = react_native_1.StyleSheet.create({
    avatarWrapper: {
        alignItems: 'center',
        marginLeft: 8,
        marginRight: 16,
        paddingBottom: 8,
    },
    badgeContainer: {
        marginLeft: 8,
    },
    badgeText: {
        fontFamily: theme_1.fontFamily,
        fontSize: 13,
    },
    constainer: {
        paddingLeft: 16,
        paddingRight: 8,
    },
    content: {
        flex: 1,
    },
    date: {
        fontFamily: theme_1.fontFamily,
        fontSize: 13,
    },
    messageAndBadge: {
        alignItems: 'center',
        flex: 1,
        flexDirection: 'row',
    },
    name: {
        flex: 1,
        fontFamily: theme_1.fontFamily,
        fontSize: 17,
        fontWeight: '500',
    },
    nameDateRow: {
        alignItems: 'center',
        flexDirection: 'row',
    },
    teaser: {
        flex: 1,
        fontFamily: theme_1.fontFamily,
        fontSize: 16,
        marginTop: 4,
    },
});
